import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management" }, { title: "menu_sidebar_management_blogs" }];

const BlogsManagementListing = Loadable({
  loader: () => import("container/management/blogs"),
  loading() {
    return <Loader />;
  }
});
export const blogsRoutes: IRoute[] = [
  {
    path: "/management/blogs",
    element: <BlogsManagementListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
